import { styled, Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';

import { Props as VMProps } from './vm';

export type Props<D extends React.ElementType<any> = 'div'> = MuiTabProps<D, { component?: D } & VMProps>;

export const StyledTab = styled(MuiTab)(({ theme }) => ({
  borderBottom: `2px solid ${theme.palette.primary[100]}`,
}));
